import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";

import HomePage from "pages/home/HomePage";
import ProductCatalog from "pages/catalog/ProductCatalog";
import ProductDetail from "pages/catalog/ProductDetail";
import Cart from "pages/cart/Cart";
import SignIn from "layouts/authentication/sign-in";
import {
  isStorefrontPreviewEmbed,
  PREVIEW_MESSAGE,
  subscribeStorefrontPreview,
} from "lib/storefrontPreview";
import { useEffect, useState } from "react";

function PreviewLoading() {
  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: "#f7f8fa", color: "#55575c", fontWeight: 700 }}
    >
      Loading storefront preview…
    </Box>
  );
}

export default function StorefrontPreviewRoot() {
  const location = useLocation();
  const navigate = useNavigate();
  const [ready, setReady] = useState(!isStorefrontPreviewEmbed());

  useEffect(() => {
    if (!isStorefrontPreviewEmbed()) {
      setReady(true);
      return undefined;
    }
    return subscribeStorefrontPreview((state) => {
      setReady(Boolean(state.ready));
    });
  }, []);

  useEffect(() => {
    function handleNavigate(event) {
      if (!isStorefrontPreviewEmbed()) return;
      try {
        const parentUrl = new URL(event.origin);
        const selfUrl = new URL(window.location.href);
        const allowed =
          parentUrl.origin === selfUrl.origin ||
          parentUrl.hostname === selfUrl.hostname ||
          parentUrl.protocol === "https:" ||
          parentUrl.hostname === "localhost";
        if (!allowed) return;
      } catch {
        return;
      }
      const data = event.data;
      if (!data || data.channel !== PREVIEW_MESSAGE || data.type !== "navigate") {
        return;
      }
      const path = String(data.payload?.path || "").trim();
      if (path) navigate(path);
    }
    window.addEventListener("message", handleNavigate);
    return () => window.removeEventListener("message", handleNavigate);
  }, [navigate]);

  if (!ready) return <PreviewLoading />;

  return (
    <Routes location={location}>
      <Route index element={<HomePage />} />
      <Route path="catalog" element={<ProductCatalog />} />
      <Route path="catalog/:documentId" element={<ProductDetail />} />
      <Route path="cart" element={<Cart />} />
      <Route path="authentication/sign-in" element={<SignIn />} />
      <Route path="*" element={<Navigate to="/storefront-preview" replace />} />
    </Routes>
  );
}
